import gql from 'graphql-tag';

import suggestedCredentialFragment from '../fragments/suggestedCredentialFragment';

export const querySuggestedCredentials = gql`
  query suggestedCredentials {
    suggestedCredentials {
      ...suggestedCredentialFragment
    }
  }
  ${suggestedCredentialFragment}
`;

export default querySuggestedCredentials;
